/**
 * Acts as a safe string pass-through for input text.
 * React inherently escapes strings before rendering, mitigating surface-level XSS.
 * Deep security parsing is deferred to the backend to allow valid characters like '<' or '>'.
 * 
 * @param {string} text 
 * @returns {string}
 */
export const sanitizeInput = (text) => {
  if (typeof text !== 'string') return text;
  return text;
};

/**
 * Trims strings that contain only whitespace to an empty string.
 * If the string contains non-whitespace characters, it is returned unchanged (not trimmed).
 * 
 * @param {string} text 
 * @returns {string}
 */
export const trimEmptySpaces = (text) => {
  if (typeof text !== 'string') return text;
  // If the string is purely whitespace, return empty string
  if (text.trim().length === 0) {
    return '';
  }
  return text;
};
